(() => {
  'use strict';
  let timer, controller, revision = 0;
  const popup = () => document.querySelector('[data-search-popup]');
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-search-open]');
    const dialog = popup();
    if (!dialog) return;
    if (trigger && typeof dialog.showModal === 'function') {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('input[type="search"]').focus();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-search-popup] input[type="search"]')) return;
    const dialog = event.target.closest('dialog'), query = event.target.value.trim();
    const list = dialog.querySelector('[data-search-results]'), status = dialog.querySelector('[data-search-status]'), all = dialog.querySelector('[data-search-all]');
    clearTimeout(timer); controller?.abort(); const current = ++revision;
    list.replaceChildren(); all.hidden = !query; list.removeAttribute('aria-busy');
    if (query.length < 2) { status.textContent = status.dataset.hint; return; }
    status.textContent = status.dataset.loading;
    timer = setTimeout(async () => {
      controller = new AbortController(); list.setAttribute('aria-busy', 'true');
      try {
        const url = new URL((window.ZariTheme?.root || '/') + 'search/suggest.json', location.origin);
        url.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last'});
        const response = await fetch(url, {signal:controller.signal,headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json(); if (revision !== current) return;
        const products = data.resources?.results?.products || [];
        for (const product of products) {
          const target = new URL(product.url, location.origin); if (target.origin !== location.origin) continue;
          const li = document.createElement('li'), a = document.createElement('a'), title = document.createElement('span');
          a.href = target.href; title.textContent = product.title;
          const source = product.featured_image?.url || product.image;
          if (typeof source === 'string' && /^(https?:)?\/\//.test(source)) { const img = document.createElement('img'); img.src = source; img.alt = ''; img.width = 64; img.height = 86; img.loading = 'lazy'; a.append(img); }
          a.append(title); li.append(a); list.append(li);
        }
        status.textContent = list.children.length ? '' : status.dataset.empty;
      } catch (error) { if (revision === current && error.name !== 'AbortError') status.textContent = status.dataset.error; }
      finally { if (revision === current) list.removeAttribute('aria-busy'); }
    }, 200);
  });
})();
